import { awsApiDomain, restApiDomain } from "@js/nwcc-domains.js";
import { hasCacheData, getFromCache, setDataCache } from "@js/service/cache.js";

export const basinData = {};
export const refData = {};

const apiDataEndpoints = ["getFcstData", "getResData", "getSnowData", "getPrecData"];

export function getBasinData(element = "all") {
    if (element === "all") {
        return basinData;
    } else {
        return basinData[element] || {};
    }
}

export function getRefData(lut = "all") {
    if (lut === "all") {
        return refData;
    } else {
        return refData[lut] || {};
    }
}

export async function fetchBasinData() {
    const requests = [fetchNetworkRefData(), fetchParents()];
    apiDataEndpoints.forEach((endpoint) => requests.push(fetchBasinElementData(endpoint)));
    await Promise.all(requests);
}

export async function fetchBasinElementData(endpoint) {
    const requestMonth = document.getElementById("month-dd").value;
    const element = endpoint.toLowerCase().replace("get", "").replace("data", "");
    if (Number(requestMonth) > 6 && element == "fcst") {
        basinData[element] = [{}];
        return [{}];
    }
    const state = document.getElementById("state-dd").value;
    const month = document.getElementById("month-dd").value;
    const year = document.getElementById("year-dd").value;
    const args = `pubMonth=${month}&pubYear=${year}&basinType=${state.toLowerCase()}`;
    const url = `${awsApiDomain}/wsor/${endpoint}?${args}&format=json`;
    // console.log(url)
    if (hasCacheData(url)) {
        basinData[element] = getFromCache(url);
    } else {
        const response = await fetch(url);
        const data = await response.json();
        basinData[element] = data;
        setDataCache(data, url);
    }
}

export async function fetchParents() {
    const state = document.getElementById("state-dd").value;
    const url = `${awsApiDomain}/basin/getParents?state=${state}&misc=true&refresh=false&format=json`;
    // console.log(url)
    if (hasCacheData(url)) {
        refData.parents = getFromCache(url);
    } else {
        const response = await fetch(url);
        const data = await response.json();
        refData.parents = data;
        setDataCache(data, url);
    }
}

export async function fetchNetworkRefData() {
    const endpoint = "reference-data";
    const args = "referenceLists=networks";
    const url = `${restApiDomain}/${endpoint}?${args}`;
    // console.log(url)
    if (hasCacheData(url)) {
        refData["networks"] = getFromCache(url);
    } else {
        const response = await fetch(url);
        const networksLut = await response.json();
        if (!Object.keys(networksLut).includes("networks")) {
            networksLut.networks = [{ code: "SNTL", description: "SNOW TELEMETRY NETWORK STATIONS" }];
        }
        const networksRefData = {};
        networksLut.networks.map((network) => {
            networksRefData[network.code] = network;
        });
        refData["networks"] = networksRefData;
        setDataCache(networksRefData, url);
    }
}
